import { Component, NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DashboardComponent } from './dashboard/dashboard.component';
import { AccountingComponent } from './dashboard/preview/accounting/accounting.component';
import { NewTemplateComponent } from './dashboard/preview/accounting/new-template/new-template.component';
import { InvoiceFolderComponent } from './dashboard/preview/invoices/invoice-folder/invoice-folder.component';
import { InvoicesComponent } from './dashboard/preview/invoices/invoices.component';
import { NewFolderComponent } from './dashboard/preview/invoices/new-folder/new-folder.component';
import { RunProcessComponent } from './dashboard/preview/invoices/run-process/run-process.component';
import { OverviewComponent } from './dashboard/preview/overview/overview.component';
import { ProfileComponent } from './dashboard/preview/profile/profile.component';
import { LoginComponent } from './login/login.component';
import { AuthGuard } from './services/auth-guard.service';
import { SifrarnikComponent } from "./dashboard/preview/sifrarnik/sifrarnik.component";
import { TemplatesComponent } from "./dashboard/preview/templates/templates.component";
import { ViberLoginComponent } from './viber-login/viber-login.component';
import { InvoicePreviewComponent } from './dashboard/preview/invoices/invoice-preview/invoice-preview.component';
import { LoadingScreenComponent } from './loading-screen/loading-screen.component';
import { FiWeComponent } from './fi-we/fi-we.component';
import { ConvertersComponent } from './dashboard/preview/converters/converters.component';
import { ConverterPageComponent } from './dashboard/preview/converters/converter-page/converter-page.component';



const routes: Routes = [
    { path: 'login', component: LoginComponent, pathMatch: 'full' },
    { path: 'loading', component: LoadingScreenComponent, },
    {
        path: '', component: DashboardComponent,
        canActivate: [AuthGuard],
        children: [
            { path: '', redirectTo: 'overview', pathMatch: 'full' },
            { path: 'overview', component: OverviewComponent, },
            { path: 'invoices', component: InvoicesComponent, },
            { path: 'converter', component: ConvertersComponent, },
            { path: 'converter-page', component: ConverterPageComponent, },
            { path: 'codebook', component: SifrarnikComponent },
            { path: 'invoices/:id', component: InvoiceFolderComponent, },
            { path: 'invoices/:id/:invoiceID', component: InvoicePreviewComponent, },
            { path: 'templates', component: TemplatesComponent },
            { path: 'fi-we', component: FiWeComponent },
            { path: 'accounting', component: AccountingComponent, },
            { path: 'profile', component: ProfileComponent, },
        ]
    },
    { path: 'new-folder', component: NewFolderComponent, canActivate: [AuthGuard] },
    { path: 'run-process', component: RunProcessComponent, canActivate: [AuthGuard] },
    { path: 'new-template', component: NewTemplateComponent, canActivate: [AuthGuard] },
    { path: 'edit-template/:id', component: NewTemplateComponent, canActivate: [AuthGuard] },
    { path: 'signup', loadChildren: () => import('./signup/signup.module').then(m => m.SignupModule) },
    { path: 'viberauth', component: ViberLoginComponent, pathMatch: 'full' },
]

@NgModule({
    imports: [RouterModule.forRoot(routes, {
        scrollPositionRestoration: 'top'
    })],
    exports: [RouterModule],
})

export class AppRoutingModule {
}
